export enum ChangePhoneNumberStep {
  SelectAccount = 'SelectAccount',
  SelectNewNumber = 'SelectNewNumber',
  CheckoutSummary = 'CheckoutSummary',
  GeneralMessage = 'GeneralMessage',
  Success = 'Success',
  CallBack = 'CallBack',
}

export const PopupContent = {
  ErrorPopup: {
    id: 'ErrorPopup',
    icon: require('app/Components/Block/OwnershipTransferPrivateSellerBlock/Icons/error.svg'),
    title: 'משהו השתבש ולא ניתן לבצע <br/> את הפעולה שביקשת',
    buttonText: 'הבנתי, תודה',
  },
  NotAvailablePopup: {
    id: 'NotAvailablePopup',
    icon: require('../Icons/hand.svg'),
    title: 'המספר שנבחר כבר לא פנוי',
    message: 'ניתן לחזור אחורה לבחירת מספר <br/> אחר מהרשימה',
    buttonText: 'לבחירת מספר אחר',
  },
};

const brandNameHe = () => window.Config?.brand_Name_HE;

export const MessageContent = {
  NoNumbersError: {
    icon: require('app/Components/Block/OwnershipTransferPrivateSellerBlock/Icons/error.svg'),
    get title() {
      return `אנחנו לא מזהים<br/> שיש לכם מנוי סלולר ב${brandNameHe()}`;
    },
    secondTitle: 'יכול להיות שנרשמתם עם פרטים אחרים?<br/>שווה לנסות להתחבר שוב',
    linkText: 'להצטרפות לשירות',
    linkAction: 'goToSale',
    contactUsButtons: false,
    whiteButtonText: 'סיום',
    whiteButtonClick: 'privateLobby',
  },
  GeneralError: {
    icon: require('app/Components/Block/OwnershipTransferPrivateSellerBlock/Icons/error.svg'),
    title: 'מצטערים, כרגע לא ניתן לבצע את <br/>הפעולה שביקשת',
    contactUsButtons: true,
    whiteButtonText: 'חזרה לאזור האישי',
    whiteButtonClick: 'privateLobby',
  },
  KosherNumberError: {
    icon: require('app/Components/Block/OwnershipTransferPrivateSellerBlock/Icons/error.svg'),
    title: 'לא ניתן לבצע את הפעולה<br/> למספר טלפון כשר',
    secondTitle: 'לפרטים נוספים יש לפנות לנציג שירות',
    contactUsButtons: true,
    whiteButtonText: 'סיום',
    whiteButtonClick: 'privateLobby',
  },
  DebtAndPaymentUpdateError: {
    icon: require('app/Components/Block/OwnershipTransferPrivateSellerBlock/Icons/creditCard.svg'),
    title: 'לפני שנמשיך בתהליך,<br/> יש לשלם את החוב בחשבון ולעדכן אמצעי תשלום',
    contactUsButtons: false,
    linkText: 'לתשלום חוב',
    linkAction: 'goToDebtPayment',
    secondLinkText: 'לעדכון אמצעי תשלום',
    secondLinkAction: 'goToUpdatePaymentPage',
    buttonText: 'חזרה לאזור האישי',
    buttonClick: 'privateLobby',
    //report: 'debtAndPaymentUpdateError',
  },
  DebtError: {
    icon: require('app/Components/Block/OwnershipTransferPrivateSellerBlock/Icons/creditCard.svg'),
    title: 'לפני שנמשיך בתהליך,<br/>יש לשלם את החוב בחשבון',
    contactUsButtons: false,
    linkText: 'לתשלום חוב',
    linkAction: 'goToDebtPayment',
    buttonText: 'חזרה לאזור האישי',
    buttonClick: 'privateLobby',
    //report: 'debtError',
  },
  PaymentUpdateError: {
    icon: require('app/Components/Block/OwnershipTransferPrivateSellerBlock/Icons/creditCard.svg'),
    title: 'לפני שנמשיך בתהליך,<br/>יש לעדכן אמצעי תשלום',
    contactUsButtons: false,
    linkText: 'לעדכון אמצעי תשלום',
    linkAction: 'goToUpdatePaymentPage',
    buttonText: 'חזרה לאזור האישי',
    buttonClick: 'privateLobby',
    //report: 'paymentUpdateError',
  },
  BusinessAccount: {
    icon: require('app/Components/Block/OwnershipTransferPrivateSellerBlock/Icons/error.svg'),
    title: 'מנוי {selectedAccount.productSubscriberNo} הינו עסקי <br/>יש לפנות לאיש הקשר בארגונך <br/>למתן שירות',
    contactUsButtons: false,
    whiteButtonText: 'לאזור האישי',
    whiteButtonClick: 'privateLobby',
    //report: 'paymentUpdateError',
  },
  OpenOrderError: {
    icon: require('app/Components/Block/OwnershipTransferPrivateSellerBlock/Icons/error.svg'),
    title: 'מסתבר שיש לכם כבר<br/> הזמנה פתוחה',
    contactUsButtons: true,
    whiteButtonText: 'לאזור האישי',
    whiteButtonClick: 'privateLobby',
    //report: 'paymentUpdateError',
  },
  NiudError: {
    icon: require('app/Components/Block/OwnershipTransferPrivateSellerBlock/Icons/error.svg'),
    title: 'מנוי {selectedAccount.productSubscriberNo} נמצא בניוד',
    secondTitle: 'כדי להמשיך את הפעולה, יש להשלים את תהליך הניוד',
    contactUsButtons: false,
    whiteButtonText: 'סיום',
    whiteButtonClick: 'privateLobby',
    //report: 'paymentUpdateError',
  },
  SuspendedLostOrStolenError: {
    icon: require('app/Components/Block/OwnershipTransferPrivateSellerBlock/Icons/error.svg'),
    title: 'מנוי {selectedAccount.productSubscriberNo} מושהה בעקבות<br/> דיווח על אובדן או גניבה',
    secondTitle: 'לפרטים נוספים יש לפנות לנציג שירות',
    contactUsButtons: true,
    whiteButtonText: 'סיום',
    whiteButtonClick: 'privateLobby',
    //report: 'paymentUpdateError',
  },
  SuspendedError: {
    icon: require('app/Components/Block/OwnershipTransferPrivateSellerBlock/Icons/error.svg'),
    title: 'מנוי {selectedAccount.productSubscriberNo} מושהה',
    secondTitle: 'לפרטים נוספים יש לפנות לנציג שירות',
    contactUsButtons: true,
    whiteButtonText: 'סיום',
    whiteButtonClick: 'privateLobby',
    //report: 'paymentUpdateError',
  },
};
